import { Link, useNavigate } from '@tanstack/react-router'
import { ArrowRight, Wallet } from 'lucide-react'
import { replaceById, useCanEdit, useUpdate, useWedding } from '@/mock/store'
import { ScreenSection } from '@/patterns/screen'
import { byDueThenPriority } from '../tasks/model'
import { CompleteToggle, TaskTable, taskColumns } from '../tasks/task-table'

export function VenueTasks({ name }: { name: string }) {
  const data = useWedding()
  const canEdit = useCanEdit()
  const update = useUpdate()
  const navigate = useNavigate()
  const tasks = data.tasks
    .filter((task) => task.context?.type === 'venue' && task.context.label === name)
    .sort((left, right) => Number(left.done) - Number(right.done) || byDueThenPriority(left, right))
  return (
    <ScreenSection
      title="Co je potřeba zařídit"
      description="Úkoly k místu jsou součástí vašeho společného svatebního plánu."
      action={
        <Link
          to="/tasks"
          className="inline-flex min-h-11 items-center gap-2 text-sm font-semibold text-action underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-ring"
        >
          Otevřít společné úkoly
          <ArrowRight className="size-3.5" aria-hidden="true" />
        </Link>
      }
    >
      <TaskTable
        tasks={tasks}
        grouped
        columns={taskColumns(data)}
        onOpen={(task) => void navigate({ to: `/tasks/${task.id}` })}
        rowAction={(task) => (
          <CompleteToggle
            task={task}
            canEdit={canEdit}
            onChange={(done) =>
              update((current) => ({
                ...current,
                tasks: replaceById(current.tasks, task.id, { done }),
              }))
            }
          />
        )}
        empty="Zatím žádné úkoly k tomuto místu. Až nějaký přidáte, najdete ho tady i ve společných úkolech."
      />
    </ScreenSection>
  )
}

export function VenueBudgetNote() {
  return (
    <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-xs text-muted-foreground">
      <Wallet aria-hidden="true" className="size-3.5 shrink-0" />
      Cenu, zálohy a platby za místa máte v rozpočtu.
      <Link
        to="/budget"
        className="font-semibold text-action underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-ring"
      >
        Otevřít rozpočet
      </Link>
    </p>
  )
}
